import React from "react";
import Assistant from "../assistant/Assistant";
import EditButton from "../buttons/EditButton";
import DeleteButton from "../buttons/DeleteButton";
import { getImage, sliceText } from "../../utils/utils";
import styled from "styled-components";
import { loadOneAxis } from "./one-axis/oneAxisAction";
import { useDispatch, useSelector } from "react-redux";
import axisSvg from "../../images/axis/axis.svg";
import { DisplayForAmbassador } from "../../permissions/DisplayAccordingToRole";

const AxisCard = ({
  axis,
  handleAxisViewOpening,
  setOpenDeleteModal,
  setOpenEditModal,
  setSelectedAxisId,
  selectedAxisId,
}) => {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.currentUser);

  const updateAxis = async (axis_id) => {
    if (axis_id !== 0) {
      setSelectedAxisId(axis_id);
      await dispatch(loadOneAxis(axis_id));
      setOpenEditModal(true);
    }
  };

  const openDeleteModal = (state) => {
    setSelectedAxisId(axis.id);
    setOpenDeleteModal(state);
  };

  return (
    <Card
      onClick={(e) => handleAxisViewOpening(axis.id, e)}
            className={axis.id === selectedAxisId ? "selected-grey selected-borders-purple" : ""}
    >
      <FirstSection>
        <DisplayForAmbassador
          hasException={
            axis.sponsor !== null && axis.sponsor.id === currentUser.id
          }
          component={<EditButton setUpdate={updateAxis} data={axis.id} />}
        />
        <DisplayForAmbassador
          component={<DeleteButton setOpenDeleteModal={openDeleteModal} />}
        />
      </FirstSection>
      <ContainerImage>
        <img src={getImage(axis.image, axisSvg)} alt={"icone de l'axe"} />
      </ContainerImage>
      <Title>
        <h2> {sliceText(axis.name, 100)} </h2>
      </Title>
    </Card>
  );
};

const Card = styled.div`
  background-color: var(--color-white);
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  -webkit-print-color-adjust: exact;
  -webkit-filter: opacity(1);
  border-radius: 15px;
  display: grid;
  grid-template-rows: 10% 50% 20%;
  width: 220px;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  padding: 0.5em;
  height: 200px;
  cursor: pointer;
  gap: 1rem;
  &:hover {
    background: var(--color-grey-03);
  }
`;

const Title = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  h2 {
    align-self: flex-start;
    font-size: 90%;
  }
`;

const ContainerImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  width: 100%;
  height: calc(200px / 2);

  img {
    object-fit: cover;
    width: 100%;
    height: 80%;
    border-radius: 15px;
  }
`;

const FirstSection = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
`;

export default AxisCard;
